module.exports = __webpack_public_path__ + "img/ic-check.1c4b99d7.svg";